import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {window} from 'ssr-window';
import {connect} from 'react-redux';
import PoweredByGoogle from '@spothero/ui/powered-by-google';
import GooglePlacesSearchInput from '@spothero/ui/google-places-search-input';
import EnvironmentUtils from '@spothero/utils/environment';

class PlaceSearch extends Component {
    static propTypes = {
        className: PropTypes.string,
        defaultValue: PropTypes.string,
        isCanadaEnabled: PropTypes.bool,
        onChange: PropTypes.func,
        onClear: PropTypes.func,
        onSelect: PropTypes.func,
        placeholder: PropTypes.string,
    };
    state = {
        country: ['us'],
    };
    _gmaps = EnvironmentUtils.isBrowser() ? window.google.maps : null;

    static getDerivedStateFromProps(nextProps, prevState) {
        const {isCanadaEnabled} = nextProps;
        const {country: prevCountry} = prevState;

        if (Boolean(prevCountry.length - 1) !== Boolean(isCanadaEnabled)) {
            return {
                country: ['us', isCanadaEnabled && 'ca'].filter(Boolean),
            };
        }

        return null;
    }

    render() {
        const {country} = this.state;
        const {
            className,
            defaultValue,
            onChange,
            onClear,
            onSelect,
            placeholder,
            ...props
        } = this.props;
        const classes = classnames('PlaceSearch', className);

        return (
            <GooglePlacesSearchInput
                {...props}
                className={classes}
                country={country}
                defaultValue={defaultValue}
                googleMaps={this._gmaps}
                onChange={onChange}
                onClear={onClear}
                onSuggestionSelect={onSelect}
                placeholder={placeholder}
                poweredByGoogleFooter={<PoweredByGoogle />}
            />
        );
    }
}

const mapStateToProps = state => {
    const {
        user: {
            data: {
                experiments: {
                    web_canada: {isFeatureEnabled: isCanadaEnabled},
                },
            },
        },
    } = state;

    return {
        isCanadaEnabled,
    };
};

export default connect(mapStateToProps)(PlaceSearch);
